package com.trevorwiebe.timesheet.mileage.domain.model

enum class LocationType { FUEL, DELIVERY }   // DELIVERY = loading & unloading

data class Location(
    val id: String,
    val name: String,
    val city: String,
    val state: String,
    val type: LocationType,
    val deleted: Boolean = false,
    val address: String = "",
    val latitude: Double? = null,
    val longitude: Double? = null
)

/** "City, ST" subtitle, blank-safe: drops either half when it's missing. */
val Location.cityState: String
    get() = listOfNotNull(
        city.takeIf { it.isNotBlank() },
        state.takeIf { it.isNotBlank() },
    ).joinToString(", ")
